import {
  ErrorResultBody,
  ForbiddenBody,
  InternalErrorBody,
  NotFoundBody,
} from '@framework/ui';
import React from 'react';

/**
 * Gestisce gli eventi in caso di errore dell'API.
 * @param message il messaggio mostrato nella pagina d'errore
 * @param description il sottotitolo mostrato nella pagina d'error.
 *                    Se presente sostituisce la descrizione dell'error.
 * @param error l'errore ricevuto dall'API da cui verrà estratta la descrizione.
 * @param status status con il codice di errore per lo switch dei componenti.
 * @param removeTopHeader se true rimuove l'header superiore (per errori nelle Tabs).
 * @returns
 */
export interface INetworkErrorPage extends INetworkErrorBodySwitchBody {
  error?: any;
  noLayout?: boolean;
}

export interface INetworkErrorBodySwitchBody {
  message: string;
  description?: string;
  status?: any;
  error?: any;
}

/**
 * Gestisce gli eventi in caso di errore dell'API.
 * @param message il messaggio mostrato nella pagina d'errore
 * @param description il sottotitolo mostrato nella pagina d'errore.
 *                    Se presente sostituisce la descrizione dell'error.
 * @param status status con il codice di errore per lo switch dei componenti.
 * @returns
 */
export function NetworkErrorBodySwitch(props: INetworkErrorBodySwitchBody) {
  const { message, status, description } = props;

  const errorProps = { message, description };

  if (status) {
    if (status === 404) {
      return <NotFoundBody {...errorProps} />;
    }
    if (status === 403) {
      return <ForbiddenBody {...errorProps} />;
    }
    if (status === 500) {
      return <InternalErrorBody {...errorProps} />;
    }
  }

  return <ErrorResultBody {...errorProps} />;
}
